import {isOrchestrationJob, type TypedJob} from "../../../metl-models/jobs/JobType.ts";
import type {ScoreResult} from "../model/ScoreResult.ts";
import {getComponentsOfType} from "../../../metl-models/jobs/component-types/jobComponentTypeFinder.ts";
import {
    pythonComponent,
    type PythonComponentDetails
} from "../../../metl-models/jobs/component-types/pythonComponent.ts";

//Libraries which are on the agent by default, these include the standard python libs and some others
// Taken from https://docs.matillion.com/data-productivity-cloud/designer/docs/python-script/#script-best-practices
const GoodLibraries = [
    "abc",	"distutils",	"nntplib",	"slugify",
    "agate",	"doctest",	"ntpath",	"smtpd",
    "aifc",	"docutils",	"nturl2path",	"smtplib",
    "annotated_types",	"dsi_pydantic_shim",	"numbers",	"sndhdr",
    "antigravity",	"email",	"numpy",	"snowplow_tracker",
    "apiclient",	"encodings",	"oauthlib",	"socket",
    "apt",	"enum",	"opcode",	"socketserver",
    "apt_inst",	"errno",	"openpyxl",	"softwareproperties",
    "apt_pkg",	"et_xmlfile",	"OpenSSL",	"sortedcontainers",
    "aptsources",	"faulthandler",	"operator",	"soupsieve",
    "argparse",	"fcntl",	"optparse",	"spwd",
    "array",	"filecmp",	"ordered_set",	"sqlite3",
    "asn1crypto",	"fileinput",	"os",	"sqlparams",
    "ast",	"filelock",	"ossaudiodev",	"sqlparse",
    "asynchat",	"fnmatch",	"packaging",	"sre_compile",
    "asyncio",	"fractions",	"pandas",	"sre_constants",
    "asyncore",	"ftplib",	"pandas_gbq",	"sre_parse",
    "atexit",	"functools",	"parsedatetime",	"ssl",
    "attr",	"future",	"pathlib",	"stat",
    "attrs",	"gc",	"pathspec",	"statistics",
    "audioop",	"genericpath",	"pdb",	"string",
    "autocommand",	"getopt",	"pickle",	"stringprep",
    "awscli",	"getpass",	"pickletools",	"struct",
    "azure_identity",	"gettext",	"pip",	"subprocess",
    "azure_keyvault_secrets",	"gi",	"pipes",	"sunau",
    "babel",	"glob",	"pkg_resources",	"symtable",
    "backports",	"google_auth_httplib2",	"pkgutil",	"sys",
    "base64",	"google_auth_oauthlib",	"platform",	"sysconfig",
    "bdb",	"google_crc32c",	"platformdirs",	"syslog",
    "binascii",	"googleapiclient",	"plistlib",	"tabnanny",
    "binhex",	"graphlib",	"poplib",	"tarfile",
    "bisect",	"grp",	"posix",	"telnetlib",
    "blinker",	"grpc",	"posixpath",	"tempfile",
    "boto3",	"grpc_status",	"pprint",	"termios",
    "botocore",	"gzip",	"profile",	"test",
    "bs4",	"hashlib",	"proto",	"text_unidecode",
    "builtins",	"heapq",	"pstats",	"textwrap",
    "bz2",	"hmac",	"psycopg2",	"this",
    "cachetools",	"html",	"pty",	"threading",
    "cairo",	"http",	"pwd",	"thrift",
    "calendar",	"httplib2",	"py_compile",	"time",
    "certifi",	"idna",	"pyarrow",	"timeit",
    "cffi",	"imaplib",	"pyasn1",	"token",
    "cgi",	"imghdr",	"pyasn1_modules",	"tokenize",
    "cgitb",	"imp",	"pyclbr",	"tomli",
    "chardet",	"importlib",	"pycparser",	"tomlkit",
    "charset_normalizer",	"importlib_metadata",	"pydantic",	"trace",
    "chunk",	"inflect",	"pydantic_core",	"traceback",
    "click",	"inspect",	"pydata_google_auth",	"tracemalloc",
    "cmath",	"io",	"pydoc",	"tty",
    "cmd",	"ipaddress",	"pydoc_data",	"turtle",
    "code",	"isodate",	"pyexpat",	"typeguard",
    "codecs",	"itertools",	"pygtkcompat",	"types",
    "codeop",	"jeepney",	"pyparsing",	"typing",
    "collections",	"jinja2",	"pytimeparse",	"typing_extensions",
    "colorama",	"jmespath",	"pytz",	"typing_inspection",
    "colorsys",	"json",	"queue",	"tzdata",
    "compileall",	"jsonschema",	"quopri",	"unicodedata",
    "concurrent",	"jsonschema_specifications",	"random",	"unittest",
    "configparser",	"jwt",	"re",	"uritemplate",
    "contextlib",	"keyring",	"readline",	"urllib",
    "contextvars",	"keyword",	"redshift_connector",	"urllib3",
    "copy",	"launchpadlib",	"referencing",	"uu",
    "copyreg",	"leather",	"reprlib",	"uuid",
    "cProfile",	"lib2to3",	"requests",	"venv",
    "crypt",	"linecache",	"requests_oauthlib",	"wadllib",
    "cryptography",	"locale",	"resource",	"warnings",
    "csv",	"logging",	"rlcompleter",	"wave",
    "ctypes",	"lsb_release",	"roman",	"weakref",
    "curses",	"lxml",	"rpds",	"webbrowser",
    "daff",	"lz4",	"rsa",	"wheel",
    "databricks",	"lzma",	"runpy",	"wsgiref",
    "dataclasses",	"mailbox",	"s3transfer",	"xdrlib",
    "datetime",	"mailcap",	"sched",	"xml",
    "dateutil",	"markupsafe",	"scramp",	"xmlrpc",
    "db_dtypes",	"marshal",	"secrets",	"xxlimited",
    "dbm",	"mashumaro",	"secretstorage",	"xxlimited_35",
    "dbt",	"math",	"select",	"xxsubtype",
    "dbt_common",	"mimetypes",	"selectors",	"yaml",
    "dbt_extractor",	"mmap",	"setuptools",	"zipapp",
    "dbt_semantic_interfaces",	"modulefinder",	"shelve",	"zipfile",
    "dbus",	"more_itertools",	"shlex",	"zipimport",
    "decimal",	"msgpack",	"shutil",	"zipp",
    "deepdiff",	"multiprocessing",	"signal",	"zlib",
    "difflib",	"netrc",	"site",	"zoneinfo",
    "dis",	"networkx",	"sitecustomize",
    "distro",	"nis",	"six",
]
const PythonBadLibraryPerComponent = -5

const TooLongLength = 100000
const TooLongLines = 300
const TooLongScore = -2

function scorePythonBadLibraries(job: TypedJob, pythons: PythonComponentDetails[]): ScoreResult<TypedJob> | undefined {
    let badLibraryTotal = 0
    let componentsWithBadLibraries = 0
    const libs = new Set<string>()
    pythons.forEach(python => {
        const pythonLibraries = python.imports
        const badLibraries = pythonLibraries.filter(library => !GoodLibraries.includes(library))
        if(badLibraries.length > 0) {
            badLibraryTotal += badLibraries.length
            componentsWithBadLibraries++
            badLibraries.forEach(x => libs.add(x))
        }
    })
    if(componentsWithBadLibraries > 0) {
        return {
            scorerId: "PYTHON_LIBRARY_DOWNWEIGHT",
            score: PythonBadLibraryPerComponent * PythonBadLibraryPerComponent,
            scoredObject: job,
            description: [`Python libraries which require additional configuration detected. [${[...libs.values()].sort((a,b)=>a.toLowerCase().localeCompare(b.toLowerCase()))}] across ${componentsWithBadLibraries} components`]
        }
    }
}

function scoreTooLong(job: TypedJob, python: PythonComponentDetails[]): ScoreResult<TypedJob> | undefined {
    const tooLong = python.filter(x => x.lineCount > TooLongLines || x.length > TooLongLength)
    if(tooLong.length > 0) {
        return {
            scorerId: "PYTHON_LENGTH_DOWNWEIGHT",
            scoredObject: job,
            score: TooLongScore,
            description: [`There are python components which are quite long, which may require rework in the DPC`]
        }
    }
}

export function scorerPythonComponents(job: TypedJob): ScoreResult<TypedJob> | undefined {
    if(isOrchestrationJob(job)) {
        const pythonComponents = getComponentsOfType(job, pythonComponent)
        if(pythonComponents.length > 0) {
            const badLib = scorePythonBadLibraries(job, pythonComponents)
            const tooLong = scoreTooLong(job, pythonComponents)
            if(!tooLong && !badLib) return undefined
            return {
                scorerId: "PYTHON_COMPONENTS",
                description: ["There are Python Script components which may need reworking"],
                score: (badLib?.score ?? 0) + (tooLong?.score ?? 0),
                children: [tooLong, badLib].filter(x => x) as ScoreResult<TypedJob>[],
                scoredObject: job
            }
        }
    }
    return undefined
}